import React, {useState, useCallback} from "react";

import Input from "./input";

import classes from "./inputwithbutton.module.css";

type Props = React.ComponentProps<typeof Input> & {
  button: React.ReactNode;
};

export default function InputWithButton({value, onFocus, onBlur, button, className, ...props}: Props) {
  const [focused, setFocused] = useState(false);

  const handleFocus = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      setFocused(true);
      onFocus?.(e);
    },
    [onFocus],
  );

  const handleBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      setFocused(false);
      onBlur?.(e);
    },
    [onBlur],
  );

  return (
    <div className={classes.wrapper}>
      <Input value={value} onFocus={handleFocus} onBlur={handleBlur} {...props} />
      {!focused && value !== "" && <div className={classes.buttonOverlay}>{button}</div>}
    </div>
  );
}
